import React from "react";
import ImageGallery from "../../../InnerNavGallery/ImageGallery";
import Cultural1 from "../../../../Assets/Images/Culturals/culturals1.jpg";
import Cultural2 from "../../../../Assets/Images/Culturals/culturals2.jpg";
import Cultural3 from "../../../../Assets/Images/Culturals/culturals3.jpg";
import Cultural4 from "../../../../Assets/Images/Culturals/culturals4.jpg";

const Sports = () => {
  return (
    <div>
      <br />
      <p>
        Cultural centers on college campuses significantly enhance student
        learning by fostering leadership development, community engagement,
        cultural identity, and a sense of belonging—all vital components of the
        learning process. Recognizing this importance, KRISAT has established a
        cultural center that provides students with a platform for
        self-expression and personal growth.
        <br />
        <br /> A senior faculty member serves as the Staff Advisor, while a
        faculty member is appointed as the Assistant Staff Advisor by the
        Principal. The Staff Advisor plays a crucial role in organizing
        students' welfare and extra-curricular activities. Faculty members from
        various disciplines act as coordinators for both academic and
        non-academic student club activities, while the Physical Director
        oversees the sports curriculum.
        <br />
        <br />
        To ensure effective functioning, the Principal nominates student
        representatives (Secretary and Joint Secretary) for various clubs and
        sports each year, forming the executive council of the Student Club. The
        Club Secretary and Games Secretary manage the literary and sports
        activities, respectively, providing every student with opportunities to
        learn, express, and develop their talents in arts, literature, debate,
        drama, and sports through various club activities.
        <br />
        <br />
        To nurture students' innate talents, KRISAT organizes cultural events,
        including TALARC, a competition among fourth-year students featuring 18
        on-stage and 10 off-stage events. Winners receive prizes, celebrating
        their achievements. Another significant event is FIESTA, an inter-year
        competition that encompasses both on-stage and off-stage activities,
        culminating in awards for overall champions and individual titles such
        as Mr. FIESTA and Ms. FIESTA.
        <br />
        <br />
        The diverse cultural programs organized by the student club at KRISAT
        since 2016 reflect the vibrant community and the commitment to fostering
        talent among students. The list of these events is provided below.
      </p>
      <br />
      <table>
        <thead>
          <tr>
            <td>S.No</td>
            <td>Year</td>
            <td>Name of the Event</td>
          </tr>
        </thead>
        <tbody>
          {" "}
          <tr>
            {" "}
            <td>1</td> <td rowspan="4">2016</td> <td>Talent Search Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>2</td> <td>Pongal Vizha</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>3</td> <td>Student Club inaugration Programme</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>4</td> <td>Sports Day & Hostel Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>5</td> <td rowspan="4">2017</td> <td>Freshers Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>6</td> <td>TALARC</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>7</td> <td>Pongal Vizha</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>8</td> <td>Sports Day & Hostel Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>9</td> <td rowspan="5">2018</td> <td>Freshers Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>10</td> <td>TALARC</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>11</td> <td>Pongal Vizha</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>12</td> <td>Club Day & College Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>13</td> <td>Sports Day & Hostel Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>14</td> <td rowspan="5">2019</td> <td>Freshers Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>15</td> <td>TALARC</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>16</td> <td>Pongal Vizha</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>17</td> <td>Club Day & College Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>18</td> <td>Sports Day & Hostel Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>19</td> <td rowspan="2">2020</td> <td>Freshers Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>20</td> <td>Pongal Vizha</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>21</td> <td rowspan="3">2021</td> <td>Freshers Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>22</td> <td>Student Club Inauguration Programme</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>23</td> <td>Farewell Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>24</td> <td rowspan="8">2022</td> <td>Freshers Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>25</td> <td>Student Club inauguration Programme</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>26</td> <td>TALARC</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>27</td> <td>Pongal Vizha</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>28</td> <td>FIESTA</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>29</td> <td>Club Day & College Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>30</td> <td>Sports Day & Hostel Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>31</td> <td>Club Closing Day & Farewell Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>32</td> <td rowspan="9">2023</td> <td>Freshers Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>33</td> <td>Student Club Inauguration Programme</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>34</td> <td>TALARC</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>35</td> <td>Food Festival</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>36</td> <td>Pongal Vizha</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>37</td> <td>FIESTA</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>38</td> <td>Club Day & College Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>39</td> <td>Sports Day & Hostel Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>40</td> <td>Club Closing Day & Farewell Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>41</td> <td rowspan="4">2024</td> <td>Freshers Day</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>42</td> <td>Student Club Inauguration Programme</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>43</td> <td>Food FIESTA</td>{" "}
          </tr>{" "}
          <tr>
            {" "}
            <td>44</td> <td>Pongal Vizha</td>{" "}
          </tr>{" "}
        </tbody>
      </table>
      <br />
      <p>
        We have participated in intercultural competitions organized in various
        colleges viz., TALENTIA at AC&RI, Madurai, CINCEF at CAT, Theni,
        AGRONOVA at TNAU, Coimbatore.
        <br />
        <br />
        Our students have participated in the inter college cultural
        competitions and bagged awards / prizes.
      </p>
      <table>
        {" "}
        <thead>
          <tr>
            <td>S.No</td>
            <td>Year</td>
            <td>Event</td>
            <td>Event Organizer</td>
            <td>KRISAT Performance</td>
          </tr>
        </thead>{" "}
        <tbody>
          {" "}
          <tr>
            <td>1</td>
            <td>2020</td>
            <td>TALENTIA</td>
            <td>AC&RI, Madurai</td>
            <td>Shipwreck</td>
          </tr>{" "}
          <tr>
            <td>2</td>
            <td>2022</td>
            <td>TALENTIA</td>
            <td>AC&RI, Madurai</td>
            <td>
              Dumb Charades, Shipwreck, Short Flim, Minute To Frame, Trailer
              Time, Art From Scribble and Non-Classical Solo.
            </td>
          </tr>{" "}
          <tr>
            <td>3</td>
            <td>2023</td>
            <td>TALENTIA</td>
            <td>AC&RI, Madurai</td>
            <td>
              Dumb Charades, Tamil Turncourt, Face Painting, Slapstick,
              Non-classical Solo, English Poetry and Word Arrows
            </td>
          </tr>{" "}
          <tr>
            <td>4</td>
            <td>2023</td>
            <td>AGRONOVA</td>
            <td>TNAU, Coimbatore</td>
            <td>Agro Fuzion</td>
          </tr>{" "}
          <tr>
            <td>5</td>
            <td>2023</td>
            <td>CINCEF</td>
            <td>CAT, Theni</td>
            <td>
              Classical Solo, Light Camera Dance, Group Fusion, Step and
              Synchronise, Song Recreation, Face Painting Connection, Vocal
              Solo, English Poetry, Tamil Poetry, Photography Trash Art, Doddle
              Art, Turn Court and Quiz
            </td>
          </tr>{" "}
          <tr>
            <td>6</td>
            <td>2024</td>
            <td>TALENTIA</td>
            <td>AC&RI, Madurai</td>
            <td>
              Just A Minute, Tamil Turn Court, Short Film, Rangoli and
              Non-classical Solo
            </td>
          </tr>{" "}
        </tbody>{" "}
      </table>{" "}
      <br />
      <ImageGallery images={[Cultural1, Cultural2, Cultural3, Cultural4]} />
    </div>
  );
};

export default Sports;
